import { L as LoopingCarousel } from './looping-carousel-cOAoL2Wk.js';
import './embla-carousel.esm-CCUHK2kO.js';
import './visibility-1aJUVV5h.js';

class TestimonialsElement extends LoopingCarousel() {
  emblaOptions = {
    loop: true,
    align: 'center',
    direction: document.dir,
    skipSnaps: true,
  };

  onInit(embla) {
    embla.on('select', () => this.#updateActiveSlide());

    this.addEventListener('click', (e) => {
      const slide = e.target.closest('.embla__slide');
      if (!slide) return;
      const index = embla.slideNodes().indexOf(slide);
      embla.goTo(index);
    });

    this.#updateActiveSlide();
  }

  #updateActiveSlide() {
    const selectedIndex = this.embla.selectedSnap();

    this.embla.slideNodes().forEach((slide, index) => {
      slide.classList.toggle('is-snapped', index === selectedIndex);
    });

    this.#updateVideos();
  }

  #updateVideos() {
    const activeIndex = this.embla.selectedSnap();

    this.embla.slideNodes().forEach((slide, index) => {
      const videoPlayer = slide.querySelector('video-player');
      if (!videoPlayer) return;

      index === activeIndex ? videoPlayer.play() : videoPlayer.pause();
    });
  }
}

customElements.define('testimonials-element', TestimonialsElement);
